<template>
  <div>
    <modal-add-waste-code ref="addWasteCodeDialog" :item="this.id" />
    <v-btn @click="showAddWasteCodeModal()">Dodaj kod</v-btn>
    <data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        class="row-pointer"
        @click:row="onRowClicked"
    >
      <template v-slot:item.id="{ item }">
      <a
          @click="onWasteCodeClicked(item.id)"
      >Usuń</a>
      </template>
    </data-table>
  </div>
</template>

<script>
import api from "@/services/api";
import DataTable from "@/components/data-table/DataTable";
import {getDatatableParams, setDatatableOptions} from "@/utils/helpers";
import ModalAddWasteCode from "./ModalAddWasteCode";

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    }
  },
  components: {
    DataTable,
    ModalAddWasteCode
  },
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      options: {},
      headers: [
        {text: 'Kod', value: 'code', sortable: false},
        {text: 'Jednostka', value: 'unit', sortable: false},
        {text: 'Opis', value: 'description', sortable: false},
        {text: 'Akcje', value: 'id', sortable: false},
      ],
    };
  },
  created() {
    getDatatableParams.call(this);
    this.getWasteCodes();
  },
  watch: {
    options: {
      handler() {
        this.getWasteCodes();
        setDatatableOptions.call(this);
      },
      deep: true,
    },
  },
  methods: {
    getWasteCodes() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      const {page, itemsPerPage} = this.options;
      const params = {
        offset: page > 1 ? itemsPerPage * (page - 1) : 0,
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      api.get(`/api/companies/${this.id}/waste-codes`, {params})
          .then((response) => {
            this.items = response.data.items;
            this.total = response.data.total;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się wczytać kodów odpadów.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onWasteCodeClicked(id) {
      api.delete(`/api/companies/${this.id}/waste-codes/${id}`)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Kod został usunięty.',
            });
            this.getWasteCodes();
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się usunąć kodu.',
              error,
            });
          });
    },
    onRowClicked(wasteCode) {
      console.log(wasteCode);
      //TODO modal to edit
    },
    async showAddWasteCodeModal() {
      this.$refs.addWasteCodeDialog
          .open()
    },
  },
}
</script>